/** Tri-state preferred_billing ↔ MUI select string values (PG admin create/view). */

export function preferredBillingToSelectValue(value) {
  if (value === true) return "true";
  if (value === false) return "false";
  return "";
}

export function preferredBillingFromSelectValue(stringValue) {
  if (stringValue === "true") return true;
  if (stringValue === "false") return false;
  return null;
}
